import React, { useEffect, useState } from "react";
import { Formik, Field, Form } from "formik";
import { TextField, Loading } from "components/form";
import { useCore } from "store/core";
import { ChevronDown, ChevronUp } from "lucide-react";
import Modal from "components/Modal";

export default function Add({ show, close, submit, title = "افزودن نقش" }) {
  const core = useCore();
  const [openGroups, setOpenGroups] = useState({});

  useEffect(() => {
    core.dispatch(core.getPermissions());
  }, []);

  const toggleGroup = (key) => {
    setOpenGroups((prev) => ({
      ...prev,
      [key]: !prev[key],
    }));
  };

  return (
    <Modal show={show} handleClose={close} title={title}>
      <Formik
        initialValues={{ name: "", faName: "", abilities: [] }}
        enableReinitialize
        onSubmit={async (values, { setSubmitting, resetForm }) => {
          const groupedPermissions = values.abilities.reduce((acc, item) => {
            const [resource, action] = item.split(".");
            if (!acc[resource]) acc[resource] = [];
            acc[resource].push(action);
            return acc;
          }, {});

          const permissions = Object.entries(groupedPermissions).map(
            ([resource, actions]) => ({
              resource: String(resource),
              actions: Array.from(new Set(actions.map(String))),
            })
          );

          const payload = {
            name: values.name,
            faName: values.faName,
            permissions,
          };

          await submit(payload);
          resetForm();
          close();
          setSubmitting(false);
        }}
      >
        {({ isSubmitting, dirty, values, setFieldValue }) => (
          <Form>
            <div className="modal-body gap-y-3">
              <div className="intro-x grid md:grid-cols-2 md:gap-3">
                <Field
                  placeholder="نام انگلیسی (مثلاً admin)"
                  label="عنوان انگلیسی :"
                  name="name"
                  component={TextField}
                />
                <Field
                  placeholder="مثلاً مدیر سیستم"
                  label="عنوان فارسی :"
                  name="faName"
                  component={TextField}
                />
              </div>

              {/* Permissions Section */}
              <div className="mt-5 space-y-4">
                {(core.permissions || []).map((perm) => {
                  const groupKey = perm.resource;
                  const isOpen = openGroups[groupKey];

                  return (
                    <div
                      key={groupKey}
                      className="border rounded bg-gray-50 shadow-sm"
                    >
                      <div
                        className="cursor-pointer px-4 py-3 flex justify-between items-center hover:bg-gray-100"
                        onClick={() => toggleGroup(groupKey)}
                      >
                        <h3 className="font-semibold text-sm text-gray-700">
                          {perm.label}
                        </h3>
                        {isOpen ? (
                          <ChevronUp size={18} />
                        ) : (
                          <ChevronDown size={18} />
                        )}
                      </div>

                      {isOpen && (
                        <div className="px-4 py-2 grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-3">
                          {perm.actions.map((action) => {
                            const val = `${perm.resource}.${action.key}`;
                            const checked = values.abilities.includes(val);

                            return (
                              <label
                                key={val}
                                className="flex items-center gap-2"
                              >
                                <input
                                  type="checkbox"
                                  className="accent-blue-600"
                                  checked={checked}
                                  onChange={() => {
                                    const current = [...values.abilities];
                                    if (checked) {
                                      setFieldValue(
                                        "abilities",
                                        current.filter((v) => v !== val)
                                      );
                                    } else {
                                      setFieldValue("abilities", [
                                        ...current,
                                        val,
                                      ]);
                                    }
                                  }}
                                />
                                <span className="text-sm text-gray-700">
                                  {action.label}
                                </span>
                              </label>
                            );
                          })}
                        </div>
                      )}
                    </div>
                  );
                })}
              </div>
            </div>

            <div className="modal-footer text-right mt-6">
              <button
                className="btn btn-primary w-20"
                type="submit"
                disabled={isSubmitting || !dirty}
              >
                {isSubmitting ? <Loading /> : "ذخیره"}
              </button>
              <button
                type="button"
                disabled={isSubmitting}
                onClick={close}
                className="btn btn-outline-secondary w-20 mr-1"
              >
                انصراف
              </button>
            </div>
          </Form>
        )}
      </Formik>
    </Modal>
  );
}
